<h2 mat-dialog-title>Create New User</h2>

<mat-dialog-content>
    <form [formGroup]="registerForm" class="register-form">

        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Display Name</mat-label>
            <input matInput formControlName="name" placeholder="ex. John Doe">
            <mat-error *ngIf="registerForm.get('name')?.hasError('required')">
                Name is required
            </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Email (Login ID)</mat-label>
            <input matInput formControlName="email" placeholder="user@example.com">
            <mat-error *ngIf="registerForm.get('email')?.hasError('required')">
                Email is required
            </mat-error>
            <mat-error *ngIf="registerForm.get('email')?.hasError('email')">
                Invalid email format
            </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Password</mat-label>
            <input matInput [type]="hidePassword ? 'password' : 'text'" formControlName="password">
            <button mat-icon-button matSuffix (click)="hidePassword = !hidePassword" type="button">
                <mat-icon>{{hidePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
            <mat-error *ngIf="registerForm.get('password')?.hasError('required')">
                Password is required
            </mat-error>
            <mat-error *ngIf="registerForm.get('password')?.hasError('minlength')">
                At least 6 characters
            </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Authority</mat-label>
            <mat-select formControlName="authority">
                <mat-option value="admin">Admin (管理者)</mat-option>
                <mat-option value="user">User (一般)</mat-option>
            </mat-select>
        </mat-form-field>

    </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancel</button>
    <button mat-flat-button color="primary" [disabled]="registerForm.invalid" (click)="onSubmit()">
        Create
    </button>
</mat-dialog-actions>